import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var RequestService = /** @class */ (function () {
    function RequestService(http) {
        this.http = http;
        this.baseUrl = environment.api_url;
    }
    RequestService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RequestService_Factory() { return new RequestService(i0.ɵɵinject(i1.HttpClient)); }, token: RequestService, providedIn: "root" });
    return RequestService;
}());
export { RequestService };
